import { Component, OnInit, OnChanges, ViewChild, ElementRef, Input, SimpleChanges } from '@angular/core';
import ReactDOM from 'react-dom'
import moment from 'moment';
import React from 'react';
import { FormControl } from '@angular/forms';
import { LocalDate, DateTimeFormatter } from 'js-joda';
import { ITravelDepartureDatepicker } from 'app/travel/travel.interfaces';
import { debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { DateRangePicker } from "@dfds-ui/react-components";
import styled from '@emotion/styled'


const DefaultDfdsStyles = styled.div`
    line-height: initial;
`

@Component({
    selector: 'sbw-date-range-picker',
    template: '<div #react></div>',
})
export class DateRangePickerComponent implements OnInit, OnChanges {

    hasInit = false
    @ViewChild('react', { static: true }) react: ElementRef

    @Input() outboundIcon: string
    @Input() returnIcon: string
    @Input() outboundLabel: string
    @Input() returnLabel: string
    @Input() h2Label: string
    @Input() infoLabel: string
    @Input() infoLegendClass: string
    @Input() departureDateControl: FormControl
    @Input() returnDateControl: FormControl
    @Input() outbound: ITravelDepartureDatepicker
    @Input() return: ITravelDepartureDatepicker

    renderSubject = new Subject()

    handleDateChange = (startDate, endDate) => {
        if (this.departureDateControl) this.departureDateControl.setValue(startDate && LocalDate.parse(startDate))
        if (this.returnDateControl) this.returnDateControl.setValue(endDate && LocalDate.parse(endDate))
    }

    ngOnInit() {
        this.hasInit = true
        this.renderSubject.pipe(debounceTime(10)).subscribe(() => this.renderReal())
        this.departureDateControl.valueChanges.subscribe(() => this.render())
        this.departureDateControl.statusChanges.subscribe(() => this.render())
        this.returnDateControl.valueChanges.subscribe(() => this.render())
        this.returnDateControl.statusChanges.subscribe(() => this.render())
        this.render()
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.hasInit) this.render()
    }

    private render() {
        this.renderSubject.next()
    }

    private renderReal() {
        ReactDOM.render(
            <DefaultDfdsStyles>
                <DateRangePicker
                    onDateChange={this.handleDateChange}
                    startDates={toDateLeg(this.outbound, this.departureDateControl.value)}
                    endDates={toDateLeg(this.return, this.returnDateControl.value)}
                    labels={{ start: this.outboundLabel, end: this.returnLabel, header: this.h2Label, info: this.infoLabel }}
                    valid={this.rangeValid()}
                    endDateDisabled={this.returnDateControl.status == "DISABLED"}
                />
            </DefaultDfdsStyles>, this.react.nativeElement)

    }

    rangeValid() {
        return this.valid(this.departureDateControl) && this.valid(this.returnDateControl)
    }

    private valid(c: FormControl) {
        return !(c && c.enabled && !c.valid)
    }

}

function getLocalDateStr(from: LocalDate): string {
    return from && from.format(DateTimeFormatter.ISO_LOCAL_DATE)
}

function toDateLeg(from: ITravelDepartureDatepicker, initial: LocalDate) {
    return {
        initial: getLocalDateStr(initial),
        maxDate: getLocalDateStr(from.maxDate),
        minDate: getLocalDateStr(from.minDate),
        disabledDates: from.disabledDates && from.disabledDates.map(d => getLocalDateStr(d)),
        offerDates: from.offerEnabledDates && from.offerEnabledDates.map(k => getLocalDateStr(k))
    }
}
